import { Search } from "@/types/types";
import styles from "../more-filters-component.module.css";
import {
  facilityRules,
  getAvailableFacilities,
  getAvailableSeachFacilities,
} from "@/lib/getFacilities/getAvailableFacilities";

export default function Facilities({
  t,
  updateSearch,
  filters,
}: {
  t: any;
  updateSearch: <K extends keyof Search>(
    key: K,
    value: Search[K]
  ) => Promise<void>;
  filters: Search;
}) {
  const facilities = getAvailableSeachFacilities(filters.type, filters.purpose);

  return (
    <div className={`${styles.filterGroup} ${styles.selectors}`}>
      <fieldset className={styles.fieldSet}>
        <legend className={styles.legend}>{t("facilitiesTitle")}</legend>
        <ul className={styles.facilitiesGrid}>
          {facilities.map((facility, index) => {
            return (
              <li key={index}>
                <button
                  onClick={async (e) => {
                    e.preventDefault();
                    await updateSearch(facility, !filters?.[facility]);
                  }}
                  className={`${styles.facility} ${
                    styles[facilityRules[facility].color]
                  } ${filters?.[facility] ? styles.facilityActive : ""} 
                  `}
                  aria-pressed={filters?.[facility]}
                >
                  <img src={facilityRules[facility].icon_url} />
                  <span>{t(facilityRules[facility].label)}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </fieldset>
    </div>
  );
}
